import viewHandlers from '@/viewHandlers'
import Rails from '@rails/ujs'
import { v4 as uuidv4 } from 'uuid'

import { updateCsrfToken } from './axios'
import bindConfirmations from './bindConfirmations'
import browserUpdateCheck from './browserUpdate'
import './dayjs'
import './i18n'
import markdownEditor from './markdownEditor'
import { setSentryContext } from './sentry'

const initialize = (container = document) => {
  // Update CSRF token first
  updateCsrfToken()
  setSentryContext()
  // React components now mounted via Stimulus controller (react_component_controller.js)
  bindConfirmations(container)
  viewHandlers(container)
  markdownEditor(container)
}

// Start Rails UJS once
try {
  Rails.start()
} catch (_e) {
  // Already started, ignore
}

// React components are now managed by Stimulus controller
// No need for manual unmounting - Stimulus disconnect() handles it

let renderedThisCycle = false

document.addEventListener('turbo:render', () => {
  renderedThisCycle = true
  initialize()
})

document.addEventListener('turbo:load', () => {
  if (!renderedThisCycle) {
    initialize()
    browserUpdateCheck()
  }
  renderedThisCycle = false
})

// For tests, expose the UUID function
window.generateUUID = () => uuidv4()

export default initialize
